import { useEffect, useRef } from "react";

import SocialMediaLinks from "./SocialMediaLinks";
import BottomMenu from "./BottomMenu";
import { useStore } from "../store";
import "./UI.css";
import Members from "../member/Members";
import Alert from "./Alert";

export default function UI(props) {
  const refBottomMenu = useRef();
  const refSocialMedia = useRef();
  const refLogo = useRef();
  const refCopyRight = useRef();
  const refScrollIndicator1 = useRef(),
    refScrollIndicator2 = useRef(),
    refScrollIndicator3 = useRef();
  const refDescription = useRef();
  const refTitleLogo = useRef();
  const refRole = useRef();
  const role1 = useStore((state) => state.role1);

  const pageNumber = 8;

  const scrollHandler = () => {
    const scrollY =
      document.querySelector("canvas").nextElementSibling.scrollTop;
    const t = scrollY / (window.innerHeight * pageNumber); // page number

    if (t < 0.2) {
      refDescription.current.style.opacity = 1 * (1 - 5 * t);
      refTitleLogo.current.style.opacity = 1 * (1 - 5 * t);
    } else {
      refDescription.current.style.opacity = 0;
      refTitleLogo.current.style.opacity = 0;
    }

    if (t < 0.5) {
      refSocialMedia.current.classList.toggle("invisible", false);
      refBottomMenu.current.classList.toggle("invisible", true);
      refRole.current.classList.toggle("invisible", true);
      refLogo.current.classList.toggle("invisible", false);
      refCopyRight.current.classList.toggle("invisible", false);
      refScrollIndicator1.current.classList.toggle(
        "scroll-indicator-active",
        true
      );
      refScrollIndicator2.current.classList.toggle(
        "scroll-indicator-active",
        false
      );
      refScrollIndicator3.current.classList.toggle(
        "scroll-indicator-active",
        false
      );
    } else if ((t >= 0.5) & (t < 0.8)) {
      refSocialMedia.current.classList.toggle("invisible", true);
      refBottomMenu.current.classList.toggle("invisible", false);
      refRole.current.classList.toggle("invisible", false);
      refLogo.current.classList.toggle("invisible", false);
      refCopyRight.current.classList.toggle("invisible", false);
      refScrollIndicator1.current.classList.toggle(
        "scroll-indicator-active",
        false
      );
      refScrollIndicator2.current.classList.toggle(
        "scroll-indicator-active",
        true
      );
      refScrollIndicator3.current.classList.toggle(
        "scroll-indicator-active",
        false
      );
    } else {
      refSocialMedia.current.classList.toggle("invisible", true);
      refBottomMenu.current.classList.toggle("invisible", true);
      refRole.current.classList.toggle("invisible", true);
      refLogo.current.classList.toggle("invisible", true);
      refCopyRight.current.classList.toggle("invisible", true);
      refScrollIndicator1.current.classList.toggle(
        "scroll-indicator-active",
        false
      );
      refScrollIndicator2.current.classList.toggle(
        "scroll-indicator-active",
        false
      );
      refScrollIndicator3.current.classList.toggle(
        "scroll-indicator-active",
        true
      );
    }
  };

  useEffect(() => {
    refBottomMenu.current.classList.toggle("invisible", true);
    refRole.current.classList.toggle("invisible", true);
    refScrollIndicator1.current.classList.toggle(
      "scroll-indicator-active",
      true
    );
    setTimeout(() => {
      const timer = setInterval(() => {
        const el = document.querySelector("canvas").nextElementSibling;
        el.addEventListener("scroll", scrollHandler);
      }, 60);
      return () => {
        const el = document.querySelector("canvas").nextElementSibling;
        clearInterval(timer);
        el.removeEventListener("scroll", scrollHandler);
      };
    }, 1000);
  }, []);

  return (
    <>
      <div ref={refRole} className="selected-role overlay">
        {role1[0]}
      </div>
      <div ref={refTitleLogo} className="overlay logo_text">
        play circle
        {/* <img
          src="assets/images/logo.png"
          alt={"large logo type of Gold Circle"}
        /> */}
      </div>
      <div ref={refDescription} className="overlay description">
        <div>
          Play Circle is a community of designers to create more fun.
          <br />
          Let’s lively communicate, inspire each other, collaborate and grow
          together.
          <br />
          Find better ways to make the most of ourselves and others.
        </div>
      </div>
      <div ref={refLogo} className="logo-wrapper">
        <a href={"/"}>
          <img
            src={"/assets/images/gold-circle_logo_n.png"}
            className={"logo show"}
            alt={"black site logo with round shape with cutting line"}
          />
        </a>
      </div>
      <div className="scroll-indicator">
        <div ref={refScrollIndicator1} className="scroll-indicator-child"></div>
        <div ref={refScrollIndicator2} className="scroll-indicator-child"></div>
        <div ref={refScrollIndicator3} className="scroll-indicator-child"></div>
      </div>
      <div ref={refCopyRight} className="copyright">
        <img
          className="show"
          src={"/assets/images/idas_logo.png"}
          alt={"idas logo"}
        />
        <span>
          2022 © Design by Tae <br />
          tr.azurewing@gmail.com
        </span>
        <span class={"dev"}>
          Developed by <br />
          www.bien.ltd
        </span>
      </div>
      <div className={"site-menu show"}></div>
      <SocialMediaLinks ref={refSocialMedia} />
      <BottomMenu ref={refBottomMenu} members={props.members} />
      <Members />
      <Alert />
    </>
  );
}
